<template>
  <div class="back-btn" v-show="backButton">
    <ul class="list-unstyled d-flex flex-wrap mx-n1">
      <a class="btn-white btn btn-sm shadow-sm" :href="href">
        <span
          class="png-icon png-icon-icons-glyph--k-arrow-left-sm mb-1 ml-0 mr-0"
        />
        <span>&nbsp; &nbsp;</span>
        BACK TO RESULTS
      </a>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      backButton: false,
      href: null
    };
  },
  mounted() {
    this.backButton = document.referrer ? true : false;
    this.href = document.referrer;
  }
};
</script>

<style>
.back-btn {
  margin:.5rem 0;
}
</style>